<template>
    <input
        class="dj-input
      h-44
      pt-12
      pb-12
      pl-16
      pr-35
      br-12
      bd-1 bd-gray-medium
      fs-14
      lh-17
      wp-100
      outline-0
    "
        :class="[extraClass, icon === 'email' ? 'pl-35' : '']"
        :name="name"
        :id="id"
        :type="type"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        :aria-invalid="ariaInvalid ? 'true' : null"
        :aria-describedby="ariaDescribedby || null"
        :readonly="readonly"
        v-model="inputValue"
        @blur="$emit('blur')"
        @change="$emit('change')"
        @focus="$emit('focus')"
        :disabled="disabled"
        @keypress="allowOnlyNumber"
        v-numeric
        :min="type === 'number' ? minNumber : null"
    />
    <div class='absolute left-16 w-14 h-14' style='top: 13px' v-if='icon==="email"'>
      <img :src="`${ASSETS_CDN}/images/general/icon-envelope.png`" alt='Envelope'/>
    </div>
    <slot name="loading"></slot>
    <div v-if="isCard">
      <slot name="card"></slot>
    </div>
</template>

<script>
import { computed } from 'vue'
import numeric from "~/directives/numeric"
import {assetCDN} from '~/helper'

export default {
  directives: {
    numeric
  },
  emits: ['blur', 'change', 'focus', 'update:modelValue'],
  props:{
    modelValue: {
      type: [Object, Array, String, Number],
      default: null
    },
    type:{
      default: 'text',
      type: String,
    },
    name:{
      default: '',
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    id:{
      default: '',
      type: String,
    },
    placeholder:{
      default: '',
      type: String,
    },
    autocomplete:{
      default: false,
      type: [Boolean, String],
    },
    isCard:{
      type: Boolean,
      default: false
    },
    extraClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    minNumber: {
      type: Number,
      default: null
    },
    icon: {
      type: String,
      default: ''
    },
    // v2 §Text Input L167/L575 — error a11y: consumer sets these when the field is invalid,
    // pointing aria-describedby at the .error-message helper id rendered below the field.
    ariaInvalid: {
      type: Boolean,
      default: false
    },
    ariaDescribedby: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const ASSETS_CDN = assetCDN()
    
    const inputValue = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    })

    const allowOnlyNumber = ($event) => {
      if(props.type === 'number') {
        let keyCode = $event.keyCode ? $event.keyCode : $event.which
        if (
          keyCode > 31 &&
          (keyCode < 48 || keyCode > 57) &&
          keyCode !== 46 &&
          keyCode !== 13
        ) {
          let regex = /^[0-9]*\.?[0-9]*$/
          if (!$event.target.value.toString().match(regex)) {
            $event.preventDefault()
          }
          $event.preventDefault()
        }

      }
    }

    // const onWheel = (event) => {
    //   event.preventDefault()
    // }

    return {
      inputValue, allowOnlyNumber,/*, onWheel*/ ASSETS_CDN
    }
  },
}
</script>
<style lang="scss" scoped>
/* Chrome, Safari, Edge, Opera */
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
